import {BaseEntity} from '../../app-common/data/BaseEntity';
import {UserDto} from '../../user/data/userDto';

export class CreateChatRoomRequest {
  participants: string[];
  roomName: string;
}

export class ChatRoom extends BaseEntity<number> {
  name: string;
}

export class ChatMessage extends BaseEntity<number> {
  chatId: number;
  message: string;
}
export class ChatRoomDto {
  room: ChatRoom;
  participants: UserDto[];
  messages: ChatMessage[];
}
export class ChatRoomCreatedDto {
  roomId: number;
  participants: string[];
}
